import styled, { css } from 'styled-components';
import { size, spacing } from 'ui/utils';
import IcSergicBadge from 'components/icons/SergicBadge';
import trim from 'lodash/trim';

const AvatarWrapper = styled.span`
   position: relative;
   display: inline-block;
   width: ${spacing(4)};
   height: ${spacing(4)};
   line-height: ${spacing(4)};
   text-align: center;
   border-radius: 100%;
   background-color: ${props => (props.isImage ? 'transparent' : props.theme.primary)};
   color: #fff;
   font-size: ${size(2)};
   background-size: cover;
   background-position: center center;
   vertical-align: middle;

   ${props =>
      props.small &&
      css`
         height: ${spacing(2)};
         width: ${spacing(2)};
         line-height: ${spacing(2)};
         font-size: ${size(-1)};
      `};

   ${props =>
      props.medium &&
      css`
         height: ${spacing(3)};
         width: ${spacing(3)};
         line-height: ${spacing(3)};
         font-size: ${size()};
      `};

   ${props =>
      props.mediumLarge &&
      css`
         height: ${spacing(4)};
         width: ${spacing(4)};
         line-height: ${spacing(4)};
         font-size: ${size(2)};
      `};

   ${props =>
      props.white &&
      css`
         background-color: #fff;
         color: #0080c8;
      `};

   ${props =>
      props.big &&
      css`
         height: ${spacing(6)};
         width: ${spacing(6)};
         line-height: ${spacing(6)};
         font-size: ${size(5)};
      `};

   ${props =>
      props.huge &&
      css`
         height: ${spacing(10)};
         width: ${spacing(10)};
         line-height: ${spacing(10)};
         font-size: ${size(8)};
      `};

   ${props =>
      props.hasShadow &&
      css`
         box-shadow: 0 8px 24px rgba(89, 149, 179, 0.15);
      `};

   ${props =>
      props.empty &&
      css`
         background-color: #ecf0f4;
      `};
`;

const SergicBadge = styled(IcSergicBadge)`
   position: absolute;
   width: 50%;
   height: 50%;
   bottom: 0;
   right: 0;
   transform: translateX(25%) translateY(25%);
   box-shadow: 0 0 4px rgba(0, 0, 0, 0.25);
   border-radius: 100%;
`;

const Avatar = ({
   name,
   firstName,
   lastName,
   displayName,
   white,
   small,
   style,
   medium,
   big,
   huge,
   avatarURL,
   hasShaddow,
   empty,
   sergicPartner,
}) => {
   if (Boolean(avatarURL)) {
      return (
         <AvatarWrapper
            white={white}
            small={small}
            medium={medium}
            big={big}
            huge={huge}
            hasShaddow={hasShaddow}
            empty={empty}
            isImage
            style={{ backgroundImage: `url(${avatarURL})` }}
         >
            {sergicPartner && <SergicBadge />}
         </AvatarWrapper>
      );
   }

   return (
      <AvatarWrapper
         style={style}
         white={white}
         small={small}
         medium={medium}
         big={big}
         huge={huge}
         hasShaddow={hasShaddow}
         empty={empty}
      >
         {displayName ? `${trim(displayName).charAt(0)}` : `${trim(firstName).charAt(0)}${trim(lastName).charAt(0)}`}
      </AvatarWrapper>
   );
};

Avatar.defaultProps = {
   firstName: '',
   lastName: '',
   displayName: '',
};

export default Avatar;
